import { getListState, getEntity, getEntityMap } from 'data'

export const APPLICATIONS_LIST_NAME = 'organization'

export const getAllApplicationsListState = getListState(APPLICATIONS_LIST_NAME)

export const getAllApplications = state => {
  return getAllApplicationsListState(state).edges.map(edge => edge.node)
}

export function getIntegrations(state) {
  return getEntityMap(state, 'Integration')
}

export function getIntegration(state, id) {
  return getEntity(state, 'Integration', id)
}

export function getApplications(state) {
  let applications = getEntityMap(state, 'Application')

  if (applications) {
    applications = applications.toArray().reduce((hash, application) => {
      return {
        ...hash,
        [application.name.toLowerCase()]: application,
      }
    }, {})

    const {
      slack,
      trello,
      asana,
      github,
      jira,
      clickup,
      ...otherApps
    } = applications

    // * We want order to be defined when we display applications to our users
    return (
      [slack, trello, asana, github, jira, clickup, ...Object.values(otherApps)]
        // Some applications might not be available or under beta flag
        // We don't want to keep undefined items in this array
        .filter(Boolean)
    )
  }

  return []
}

export function getApplication(state, id) {
  return getEntity(state, 'Application', id)
}

export function getApplicationWithFeatures(state, features = []) {
  return getApplications(state).filter(application => {
    return features.every(feature => application.features.includes(feature))
  })
}
